import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7sxzf99szh: FaireBrandEntity = {
  token: "b_7sxzf99szh",
  type: "brand",
  name: "Christian Beauty Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/0d553318b2e68ac9f53018a2f54ef5b53ca5e0422504acf7d80374431ead7d83.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf262804f5e5d8722df88b42fa7da59a85e6a2270e44f0e34b67f8918b1b7202.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0d553318b2e68ac9f53018a2f54ef5b53ca5e0422504acf7d80374431ead7d83.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf262804f5e5d8722df88b42fa7da59a85e6a2270e44f0e34b67f8918b1b7202.png",
  location: "Mantua, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Christian Beauty Co. was born from a search for skincare and makeup that aligned with strong, uncompromising values. We were tired of choosing between performance, ingredients, and integrity; so we created the brand we longed to support. Every product is crafted in small batches in New Jersey, with thoughtful formulations, clean ingredients, and careful attention to detail. Our name is a daily reminder that what we create should reflect honesty, stewardship, and love for people.\n\nOur mission is to honor the God-given design in every face by offering high-quality skincare and cosmetics that truly nourish the skin. We focus on effective, cleaner ingredients and inclusive shade ranges so that more people can see themselves beautifully represented. Luxury and ethics should not be at odds, and we are committed to making purposeful, high-performing beauty accessible without compromise.\n\nChristian Beauty Co. is more than a brand; it’s a values-driven movement where authenticity, self-care, and conviction meet. We invite you to embrace your natural radiance with products that are as pure in purpose as they are in formulation. Our commitment is to lead with transparency, innovation, and unwavering Christian values in everything we do.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:51.638Z",
    importedBy: "entity-db-cli",
  },
};
